/* (c) Copyright Frontify Ltd., all rights reserved. */

export const BOX_BG_ALIAS_TOKENS_CLASSES = [
    'tw-bg-box-neutral',
    'tw-bg-box-neutral-strong',
    'tw-bg-box-selected',
    'tw-bg-box-selected-strong',
    'tw-bg-box-disabled',
    'tw-bg-box-disabled-strong',
    'tw-bg-box-positive',
    'tw-bg-box-positive-strong',
    'tw-bg-box-negative',
    'tw-bg-box-negative-strong',
    'tw-bg-box-warning',
    'tw-bg-box-warning-strong',
];

export const BOX_TEXT_ALIAS_TOKENS_CLASSES = [
    'tw-text-box-neutral-inverse',
    'tw-text-box-neutral-strong-inverse',
    'tw-text-box-selected-inverse',
    'tw-text-box-selected-strong-inverse',
    'tw-text-box-disabled-inverse',
    'tw-text-box-disabled-strong-inverse',
    'tw-text-box-positive-inverse',
    'tw-text-box-positive-strong-inverse',
    'tw-text-box-negative-inverse',
    'tw-text-box-negative-strong-inverse',
    'tw-text-box-warning-inverse',
    'tw-text-box-warning-strong-inverse',
];
